import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Sparkles, Zap, Star, Crown, ExternalLink } from "lucide-react";
import { useAnalytics } from "@/hooks/useAnalytics";

/**
 * Grid de 4 planos com links de pagamento Ton.
 * Reaproveitado na HomePage e na PagamentoPage (mesmo visual).
 * Anual atualizado para R$ 189,90.
 */
const PlanosCardsTon: React.FC<{ origin?: string; page?: string }> = ({
  origin = "home",
  page = "/",
}) => {
  const { track } = useAnalytics();

  const plans = [
    {
      title: "Experimente 15 dias",
      price: "27,90",
      period: "/15 dias",
      link: "https://payment-link-v3.ton.com.br/pl_jmE3QdVoaOkNQxyT0qFpPWqpbYzBAxXw",
      icon: <Sparkles className="h-6 w-6" />,
      popular: false,
      badge: "Experimente",
      color: "from-emerald-500 to-teal-600",
      visible: false,
    },
    {
      title: "Plano Mensal",
      price: "44,90",
      period: "/mês",
      link: "https://payment-link-v3.ton.com.br/pl_ZQwzvp2lJo7NmVQHDxSzXV5YLBM6rP0A",
      icon: <Zap className="h-6 w-6" />,
      popular: false,
      color: "from-blue-500 to-blue-600",
      visible: true,
    },
    {
      title: "Plano Trimestral",
      price: "59,90",
      period: "/trimestre",
      link: "https://payment-link-v3.ton.com.br/pl_MOmQDl0pqL34xMDFQOfyRWdVvkN1aYZg",
      icon: <Star className="h-6 w-6" />,
      popular: true,
      color: "from-primary to-purple-600",
      visible: true,
    },
    {
      title: "Plano Anual",
      price: "189,90",
      period: "/ano",
      link: "https://payment-link-v3.ton.com.br/pl_L70p9dexNmVXEJeJTLU3AgoaMrlk5Zb2",
      icon: <Crown className="h-6 w-6" />,
      popular: false,
      color: "from-amber-500 to-orange-600",
      visible: true,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {plans.filter((plan) => plan.visible).map((plan) => (
        <Card
          key={plan.title}
          className={`relative overflow-hidden transition-transform hover:scale-105 ${
            plan.popular
              ? "border-primary shadow-lg shadow-primary/20 ring-2 ring-primary"
              : "border-border"
          }`}
        >
          {plan.popular && (
            <Badge className="absolute top-3 right-3 bg-primary text-primary-foreground">
              Mais Popular
            </Badge>
          )}
          {plan.badge && !plan.popular && (
            <Badge className="absolute top-3 right-3 bg-emerald-500 text-white">
              {plan.badge}
            </Badge>
          )}
          <CardHeader className="text-center pb-2">
            <div
              className={`mx-auto w-14 h-14 rounded-full bg-gradient-to-br ${plan.color} flex items-center justify-center text-white mb-3`}
            >
              {plan.icon}
            </div>
            <CardTitle className="text-lg">{plan.title}</CardTitle>
          </CardHeader>
          <CardContent className="text-center">
            <div className="mb-4">
              <span className="text-sm text-muted-foreground">R$</span>
              <span className="text-4xl font-extrabold text-foreground">
                {plan.price}
              </span>
              <span className="text-muted-foreground">{plan.period}</span>
            </div>
            <a
              href={plan.link}
              target="_blank"
              rel="noopener noreferrer"
              className="block"
              onClick={() => {
                const meta = {
                  origin,
                  method: "ton",
                  provider: "ton",
                  page,
                  plan: plan.title,
                };
                track("direct_payment_nubank_click", meta);
                track("checkout_click", meta);
              }}
            >
              <Button
                className={`w-full text-white ${
                  plan.popular
                    ? "bg-primary hover:bg-primary/90"
                    : "bg-foreground/80 hover:bg-foreground/70"
                }`}
                size="lg"
              >
                Assinar Agora
                <ExternalLink className="ml-2 h-4 w-4" />
              </Button>
            </a>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default PlanosCardsTon;
